import type {
  ExactOptionContractMeasurement,
  MovingAverageTriggerMode,
} from "./watchSignalReleaseRegistry";
import { canonicalRatioToPercent } from "./watchRatioPresentation";

const MEASUREMENT_COPY: Readonly<Record<ExactOptionContractMeasurement, string>> = {
  IMPLIED_VOLATILITY: "Implied volatility",
  NBBO_RELATIVE_SPREAD: "Bid/ask spread",
  REGULAR_SESSION_VOLUME: "Session volume",
  OPEN_INTEREST: "Open interest",
};

/** Human-readable review copy for a validated exact-contract condition. */
export function describeOptionCondition(
  measurement: ExactOptionContractMeasurement,
  triggerMode: MovingAverageTriggerMode,
  direction: "ABOVE" | "BELOW",
  threshold: string,
  targetLegIndex?: number,
) {
  const subject = targetLegIndex === undefined ? "this option" : `option leg ${targetLegIndex + 1}`;
  const level = measurement === "IMPLIED_VOLATILITY" || measurement === "NBBO_RELATIVE_SPREAD"
    ? `${canonicalRatioToPercent(threshold)}%`
    : `${threshold} contracts`;
  const comparison = triggerMode === "CROSSING"
    ? direction === "ABOVE" ? "newly crosses above" : "newly crosses below"
    : direction === "ABOVE" ? "is at or above" : "is at or below";
  return `${MEASUREMENT_COPY[measurement]} for ${subject} ${comparison} ${level}.`;
}
